import 'ress';
import 'core-js/stable';
import '../scss/style.scss';
import common from './common';
import slider from './slider';

common();
slider();
